import type { ReactNode } from 'react'

/** A founder's own words, set apart. The one place the design uses its darker well colour. */
export function QuoteBlock({ children }: { children: ReactNode }) {
  // The prototype's quote well is a fixed near-black, darker than any surface token.
  return (
    <blockquote className="rounded-lg bg-[#0F0F10] px-3 py-2.5 text-sm leading-relaxed text-foreground/85">
      {children}
    </blockquote>
  )
}
